import { render, staticRenderFns } from "./StepOneTournament.vue?vue&type=template&id=81335540&scoped=true&"
import script from "./StepOneTournament.vue?vue&type=script&lang=js&"
export * from "./StepOneTournament.vue?vue&type=script&lang=js&"
import style0 from "./StepOneTournament.vue?vue&type=style&index=0&id=81335540&lang=stylus&scoped=true&"
import style1 from "./StepOneTournament.vue?vue&type=style&index=1&id=81335540&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81335540",
  null
  
)

export default component.exports